import styled from '@emotion/styled'

import { Container } from '@/components/Container'
import { CONFIG } from '@/styles/emotion.config'

export const MediaWithFormsContainer = styled(Container)`
  margin-top: -1px;
  .media-with-forms__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.5rem 1rem;
    gap: 1rem;
  }

  .media-with-forms__image {
    width: 18.75rem;
    height: 16.17rem;
  }

  .media-with-forms__inputs {
    &__partner-logo {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 8.2rem;
      height: 3.2rem;
    }

    &__serasa-logo {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 4.2rem;
      height: 2.125rem;
    }
  }

  ${CONFIG.media.xlg} {
    .media-with-forms__content {
      display: grid;
      grid-template-columns: auto auto;
      grid-template-rows: auto auto auto auto;
      gap: 0 4rem;
      row-gap: 1rem;
      grid-auto-flow: row;
      padding: 0;
    }

    .media-with-forms__content--left {
      grid-template-areas:
        'image title'
        'image subtitle'
        'image inputs';
    }

    .media-with-forms__content--right {
      grid-template-areas:
        'title image'
        'subtitle image'
        'inputs image';
    }

    .media-with-forms__content--right > .media-with-forms__image {
      margin-left: auto;
    }

    .media-with-forms__content--left > .media-with-forms__image {
      margin-right: auto;
    }

    .media-with-forms__image {
      grid-area: image;
      width: fit-content;
      height: fit-content;
      margin-bottom: auto;
    }

    .media-with-forms__title {
      grid-area: title;
    }

    .media-with-forms__subtitle {
      grid-area: subtitle;
    }

    .media-with-forms__inputs {
      grid-area: inputs;

      &__partner-logo {
        width: unset;
        height: unset;
      }

      &__serasa-logo {
        width: unset;
        height: unset;
      }
    }

    .media-with-forms__footer {
      grid-area: footer;
    }
  }
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const Form = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3rem;
`

export const FormInput = styled.input`
  width: 100%;
  height: 100%;

  border: 0.125rem solid rgba(255, 255, 255, 0.5);
  border-radius: 5.813rem 0 0 5.813rem;

  padding: 0.75rem 2.75rem 0.75rem 1rem;

  color: #fff;
  background-color: transparent;
  font-family: 'Roboto', sans-serif;
  font-size: 1rem;

  ${CONFIG.media.xlg} {
    padding: 1.375rem 2rem;
  }

  ::placeholder {
    color: #fff;
    opacity: 0.5;
  }

  :focus {
    border: 0.125rem solid rgb(255, 255, 255);
  }
`
export const FormSubmitButton = styled.button`
  height: 100%;
  border-radius: 5.813rem;
  margin-left: -2rem;
  cursor: pointer;

  padding: 0.75rem 2rem;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: rgb(var(--colors-pink));
  color: #fff;
  border: none;
  font-weight: bold;
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;

  ${CONFIG.media.xlg} {
    font-size: 1rem;
    padding: 1.375rem 2rem;
  }

  transition: ease-in-out all 0.2s;

  :hover {
    filter: brightness(0.9);
  }

  :focus {
    filter: brightness(1.2);
  }
`

export const FormFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  flex-wrap: wrap;

  ${CONFIG.media.xlg} {
    column-gap: 1.5rem;
    row-gap: 0.5rem;
  }
  .link-integrity__footer__disclaimer {
    font-size: 0.75rem;
    line-height: 1rem;
  }
  .document-consulting__footer__disclaimer {
    margin-top: 1rem;
    font-size: 0.75rem;
    line-height: 1rem;
    ${CONFIG.media.xlg} {
      margin-top: 0.5rem;
    }
  }
`

export const FormFooterVerticalDivider = styled.span`
  width: 0.063rem;
  height: 1.693rem;
  background-color: #fff;

  ${CONFIG.media.xlg} {
    height: 4.658rem;
  }
`
